import StudentClassroomApi from './StudentClassroomApi';
export default StudentClassroomApi;
